<script setup>
import { useFooterSectionStore } from '@/stores/footer_sections';
import { useGeneralStore } from '@/stores/general';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const footerSectionStore = useFooterSectionStore();
const generalStore = useGeneralStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const openLiveChat = () => {
	const y = window.scrollY || window.pageYOffset || 0;
	document.activeElement?.blur?.();

	platformConfigurationStore.openLiveChat();

	// Tawk.to locks the body on maximize — clean up after the toggle
	if (window.Tawk_API) {
		requestAnimationFrame(() => {
			const body = document.body;
			const html = document.documentElement;
			['position', 'top', 'left', 'right', 'width', 'height', 'min-height', 'max-height', 'max-width', 'overflow']
				.forEach(prop => body.style.removeProperty(prop));
			html.style.removeProperty('overflow');
			if (location.hash === '#max-widget') {
				history.replaceState(null, document.title, location.pathname + location.search);
			}
			window.scrollTo(0, y);
		});
	}
};

</script>

<template>
	<template v-if="footerSectionStore.getLivechatSection">
		<div class="contact-flex">
			<div class="mobile-width">
				<a href="javascript:void(0);" @click.prevent="openLiveChat" class="btn-small btn-secondary" :class="{ 'btn-gradient': generalStore.getGeneral?.use_gradient_color_as_button }" style="height: 39px; width: 140px;">{{ $t('general.live_chat') }}</a>
			</div>
		</div>
	</template>
</template>

<style scoped>
.contact-flex {
	display: flex;
	align-items: flex-end;
	justify-items: start;
	flex-wrap: wrap;
	gap: 10px;
}
.contact-title {	color: var(--white);
	font-size: 13px;
	text-align: center;
	font-weight: 700;
	padding-bottom: 5px;
}
.contact-number {
	color: var(--primary);
	font-weight: 700;
	text-decoration: none;
}

.contact-number-ussd {
	color: var(--primary);
	font-weight: 700;
}

.no-hover {
	color: var(--primary);
	font-weight: 700;
	pointer-events: none;
	cursor: default;
}

.no-border {
	border: none;
	text-align: left;
}

@media screen and (max-width: 767px){
	.contact-flex {
		justify-content: space-between;
	}

	.btn-small {
		font-size: 13px;
		text-wrap: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mobile-width {
		width: 44%;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.btn-small {
		font-size: 13px;
		padding: 7px;
	}
}
</style>